<template>
  <div class="base-container">
    <div class="avatar-box">
      <img class="avatar" :src="styleData.cover.value" />
      <div class="level-box">
        <img class="level-icon" :src="dataSource.level.value" />
      </div>
    </div>
    <div class="preview-box">
      <div class="cv">CV：{{ dataSource.cv.value }}</div>
      <div class="name">{{ dataSource.name.value }}</div>
      <div class="date">[ 实装时间：{{ dataSource.szrq.text.value }} ·] [ 部队：{{ dataSource.bd.text.value }} ·]</div>
      <div class="attr-wrapper">
        <el-tooltip class="attr-item" :content="'阶段：' + dataSource.jd.text.value" placement="top">
          <div class="attr-item-icon">
            <img :src="dataSource.jd.icon.value" alt="阶段" />
          </div>
        </el-tooltip>
        <el-tooltip class="attr-item" :content="'属性：' +dataSource.sx.text.value" placement="top">
          <div class="attr-item-icon">
            <img :src="dataSource.sx.icon.value" alt="属性" />
          </div>
        </el-tooltip>
        <el-tooltip class="attr-item" :content="'职业：' + dataSource.zy.text.value" placement="top">
          <div class="attr-item-icon">
            <img :src="dataSource.zy.icon.value" alt="职业" />
          </div>
        </el-tooltip>
        <el-tooltip class="attr-item" :content="'企业：' + dataSource.qy.text.value" placement="top">
          <div class="attr-item-icon">
            <img :src="dataSource.qy.icon.value" alt="企业" />
          </div>
        </el-tooltip>
        <el-tooltip class="attr-item" :content="'武器：' +dataSource.wq.text.value" placement="top">
          <div class="attr-item-icon">
            <img :src="dataSource.wq.icon.value" alt="武器" />
          </div>
        </el-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Base",
  props: {
    dataSource: { type: Object, default: () => ({}) },
    styleData: { type: Object, default: () => ({}) }
  },
};
</script>

<style lang="less" scoped>
.base-container {
  display: flex;
  column-gap: 22px;
  position: relative;
  z-index: 3;
  width: 660px;
  min-height: 208px;
  padding: 25px 0 0 13px;
  background: url("~@/assets/nikke_imgs/role-base.png") no-repeat;
  background-size: 100% 100%;
  cursor: default;
  .avatar-box {
    position: relative;
    width: 112px;
    height: 165px;
    overflow: hidden;
    background: url("~@/assets/nikke_imgs/role-base-avatar.png") left top/cover no-repeat;
    .avatar {
      display: block;
      width: 100%;
    }
    .level-box {
      position: absolute;
      top: 2px;
      left: 10px;
      width: 35px;
      height: 55px;
      background: url("~@/assets/nikke_imgs/role-base-ssrbg.png") center top/cover no-repeat;
      .level-icon {
        position: absolute;
        width: 39px;
        height: 39px;
        top: 3px;
        left: 9px;
      }
    }
  }
  .preview-box {
    .cv {
      font-weight: 500;
      font-size: 13px;
      color: rgba(20,38,48,0.7);
      padding-left: 140px;
      padding-top: 6px;
    }
    .name {
      width: 100%;
      height: 45px;
      line-height: 45px;
      text-indent: 20px;
      //text-align: center;
      color: #333;
      font-size: 24px;
      font-weight: bold;
      margin-top: 5px;
    }
    .date {
      color: #142630;
      font-size: 13px;
      margin-top: 20px;
    }
    .attr-wrapper {
      display: flex;
      column-gap: 16px;
      margin-top: 16px;
      .attr-item-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        background: url("~@/assets/nikke_imgs/role-base-attr.png") center/cover no-repeat;
        img {
          width: 26px;
          height: 26px;
          object-fit: contain;
          object-position: center;
        }
      }
    }
  }
}
</style>
